import { render } from "./MyFileList.vue?vue&type=template&id=d354a50e&scoped=true"
import script from "./MyFileList.vue?vue&type=script&lang=js"
export * from "./MyFileList.vue?vue&type=script&lang=js"

import "./MyFileList.vue?vue&type=style&index=0&id=d354a50e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d354a50e"]])

export default __exports__